
import { Outlet, Link, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import {
  LayoutDashboard,
  Users,
  ShoppingCart,
  BarChart3,
  Settings,
  Calendar,
  Monitor,
  Menu,
  X,
  Warehouse,
  ShieldCheck,
} from 'lucide-react'
import { useState } from 'react'

export default function MainLayout() {
  const location = useLocation()
  const { user } = useAuthStore()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const navItems = [
    { path: '/app/pos', icon: LayoutDashboard, label: 'POS' },
    { path: '/app/touch-pos', icon: Monitor, label: 'Touch POS' },
    { path: '/app/inventory', icon: Warehouse, label: 'Inventory' },
    { path: '/app/customers', icon: Users, label: 'Customers' },
    { path: '/app/orders', icon: ShoppingCart, label: 'Orders' },
    { path: '/app/reports', icon: BarChart3, label: 'Reports' },
    { path: '/app/business-day', icon: Calendar, label: 'Business Day' },
    { path: '/app/management', icon: ShieldCheck, label: 'Management' },
    { path: '/app/settings', icon: Settings, label: 'Settings' },
  ]

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className={`bg-gray-900 text-white transition-all duration-300 ${sidebarOpen ? 'w-64' : 'w-18'}`}>
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          {sidebarOpen && <h1 className="text-xl font-bold">Elysium POS</h1>}
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="p-2 hover:bg-gray-700 rounded">
            {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>

        <nav className="mt-4">
          {navItems.map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.path || 
                           (item.path === '/app/pos' && location.pathname === '/app')
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 hover:bg-gray-700 transition-colors ${
                  isActive ? 'bg-blue-900 border-l-4 border-white' : ''
                }`}
              >
                <Icon size={20} />
                {sidebarOpen && <span>{item.label}</span>}
              </Link>
            )
          })}
        </nav>

        <div className="absolute bottom-0 left-0 right-0 border-gray-700 p-4">
          <div className={`flex items-center gap-3 ${sidebarOpen ? '' : 'justify-center'}`}>
            {sidebarOpen && (
              <div className="flex-1">
                <p className="text-sm font-medium">{[user?.first_name, user?.last_name].filter(Boolean).join(' ') || user?.email}</p>
                <p className="text-xs text-gray-400">{user?.roles?.[0] || 'User'}</p>
              </div>
            )}
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}
